import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import UserService from "../../../services/user-service.js";
const ViewUser = () => { 
    
const [user, setUser] = useState({});
const [loading, setLoading] = useState(false);
const { id } = useParams();
const navigate = useNavigate()

    const getUser = () => {
        setLoading(true);
        UserService.getUserDetails(id)
              .then(response => {
                const data =response.data.data
                setUser(data)
                setLoading(false);
              })
              .catch(error => {
                setLoading(false);
                try {
                  const errorMessage = error.response.data
                  toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
                } catch (e){
                  toast.error( MESSAGES.SERVER_ERROR)
                }
              });
      }
    useEffect(() => {
        getUser();
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
const back = () => {
  navigate(-1); 
}

return(
  <div>
  <LoaderOverlay loading={loading} />
  <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
  <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>View Details</h4>
  <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Profile Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">USER ID</label>
                  <p>{user.user_id}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">FULL NAME</label>
                  <p>{user.full_name}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">EMAIL ADDRESS</label>
                  <p>{user.email_address}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">MOBILE NUMBER</label>
                  <p>{user.mobile_number}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">{user.status_id}</label>
                  <p>1</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATUS</label>
                  <p>{user.status}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CUSTOMER ID</label>
                  <p>{user.customer_id}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">USER TYPE</label>
                  <p>{user.user_type}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">AGENT ID</label>
                  <p>{user.agent_id}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">SUPERVISOR</label>
                  <p>{user.supervisior || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Role</label>
                  <p>{user.role && user.role.role_name || '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">LIMIT GROUP ID</label>
                  <p>{user.limit_grp_id || '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">DATE OF BIRTH</label>
                  <p>{user.date_of_birth || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">GENDER</label>
                  <p>{user.gender || '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">GENDER ID</label>
                  <p>{user.gender_id || '-'}</p>
                </div>
              </div> */}
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">IS VERIFICATION PENDING</label>
                  <p>{user.is_verification_pending ? 'true' : 'false'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">NATIONAL ID</label>
                  <p>{user.national_id || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">COMMISION GROUP NAME</label>
                  <p>{user.comm_grp_name || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">LIMIT GROUP NAME</label>
                  <p>{user.limit_grp_name || '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PROFILE PHOTO</label><br />
                  <img style={{margin: 0}} src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Address Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ADDRESS 1</label>
                  <p>{user.address && user.address.address1 ? user.address.address1 : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ADDRESS 2</label>
                  <p>{user.address && user.address.address2 ? user.address.address2 : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CITY ID</label>
                  <p>{user.address && user.address.city_id ? user.address.city_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CITY</label>
                  <p>{user.address && user.address.city ? user.address.city : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATE ID</label>
                  <p>{user.address && user.address.state_id ? user.address.state_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATE</label>
                  <p>{user.address && user.address.state ? user.address.state : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ZIP</label>
                  <p>{user.address && user.address.zip ? user.address.zip : '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {user.balances && (
      <>
       <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Balance Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PAY IN BALANCE</label>
                  <p>₹{user.balances && user.balances.pay_in_balance ? user.balances.pay_in_balance : 0}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PAY OUT BALANCE</label>
                  <p>₹{user.balances && user.balances.blocked_amount ? user.balances.blocked_amount : 0}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">AUTO GENERATE PASSWORD</label>
                  <p>{user.auto_generate_password ? 'true' : 'false' }</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CREATED BY</label>
                  <p>{user.created_by || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CREATED ON</label>
                  <p>{user.created_on || '-'}</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
      </>
    )}
   
    <a style={{width: 'auto', padding: '0px'}} onClick={back}><button className="btn btn-bg-theme-Color backbt">Back</button></a>
    
   
  </div>
</div>

</div>

)

} 
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
  export default withAuth(connect(mapStateToProps)(ViewUser));